import { EntityType } from 'const';
import * as Models from 'models';
import { getValue } from 'utils/getter';

export function isReferenceCitation(document: Models.CombinedDocument): document is Models.ReferenceCitation;
export function isReferenceCitation(document: Models.CombinedDocumentMap): document is Models.ReferenceCitationMap;
export function isReferenceCitation(document): boolean {
  return getValue(document, 'entityType') === EntityType.REFERENCE_CITATION;
}
